import styled from "styled-components";

export const LicenseWrapper = styled.div`
  width: 50%;
  
  > div {
    width: 100%;
    display: block;
  }
`;